import { render, staticRenderFns } from "./IMRPDF.vue?vue&type=template&id=71743365"
import script from "./IMRPDF.vue?vue&type=script&lang=js"
export * from "./IMRPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports